import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface StoreInvestmentPayload {
  investmentTypeSlug: string;
  name: string;
  primaryValue: number;
  currencyUuid: string;
  quantity?: number | null;
  purchaseRate?: number | null;
  additionalInfo?: string | null;
  relianceCanView: boolean;
  details?: Record<string, unknown>;
}

export const useStoreInvestment = (
  options?: UseMutationOptions<any, Error, StoreInvestmentPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["storeInvestment"],
    mutationFn: async (data: StoreInvestmentPayload) => {
      return axiosInstance
        .post("/investments", data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "store-investment",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas dodawania aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "store-investment",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
